import { useContext } from 'react';

import { FormContext } from '~/contexts/FormContext/FormContext';
import { DefaultFormType, FormContextType } from '~/contexts/FormContext/types';

export const useFormContext = <T extends DefaultFormType = DefaultFormType>() =>
  useContext(FormContext) as FormContextType<T>;
